import { ChakraProvider, Flex } from "@chakra-ui/react";
import theme from "theme/theme";
import LandingPage from "views/Home/LandingPage/LandingPage"
import { Redirect, Route, Switch } from 'react-router-dom';

import DocumentationOverview from "views/Home/Documentation/DocumentationOverview";
import DocumentationDetail from "views/Home/Documentation/DocumentationDetail";
import Header from "views/Home/LandingPage/Header";

export default function Home() {
  return (
    <ChakraProvider theme={theme}>
        <Header/>
        <Switch>
            <Route path="/" component={DocumentationOverview} />
            <Route path="/det" component={DocumentationDetail} />
        </Switch>
    </ChakraProvider>
  );
}
